'use strict';

// ----------------------------------------
// Imports
// ----------------------------------------

import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';
import ScrollMagic from 'scrollmagic';
import TweenMax from 'gsap/src/uncompressed/TweenMax'; // eslint-disable-line no-unused-vars
import TimelineMax from 'gsap/src/uncompressed/TimelineMax';
require('scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap');

// ----------------------------------------
// Private
// ----------------------------------------

let headerMenuWrap = '.header-menu__wrap';
let headerMenu = $('.header-menu--move');
let logoMove = $('.index-header__logo--move');
let socialMove = $('.index-header__social-wrap--move');
let $infoItem = $('.index-info__wrap');
let $productInfo = $('.item__info-wrap');
let calculatorWrap = '.calculator__wrap';
let calculatorMain = '.calculator__profit';
let calculatorLeft = '.calculator__gas';
let calculatorRight = '.calculator__electro';
let mainText = '.main-slider__text-wrap.animated';
let mainCircle = '.main-slider__circle.animated';
let $counter = $('.counter');
let count = $counter.data('count');

// ----------------------------------------
// Public
// ----------------------------------------

function firstSlideAnimation () {
	if (!mainText.length) {
		return false;
	}

	if ($(window).width() < 1024) {
		return false;
	}

	//	create timeline for main screen
	let tlMain = new TimelineMax({paused: false});

	tlMain
		.staggerTo(mainCircle, 1, {scale: 1, autoAlpha: 1, ease: Power1.easeIn}) // eslint-disable-line no-undef
		.staggerTo(mainText, 1, {x: 0, autoAlpha: 1, ease: Power1.easeOut}); // eslint-disable-line no-undef
}

function headerScrollMagic () {
	let left = $(window).width() < 1800 ? 190 : 265;

	if (!$(headerMenuWrap).hasClass('move')) {
		return false;
	}

	const controller = new ScrollMagic.Controller();
	let tlHeader = new TimelineMax({paused: true});

	// create timeline for header menu
	tlHeader
		.to(headerMenu, 0.3, {x: left, ease: Power1.easeOut}) // eslint-disable-line no-undef
		.to(logoMove, 0.3, {x: 0, autoAlpha: 1, ease: Power1.easeOut}) // eslint-disable-line no-undef
		.from(socialMove, 0.3, {y: -300, autoAlpha: 0, ease: Power1.easeOut}, 0.5); // eslint-disable-line no-undef

	// create pin scene for header
	const headerScene = new ScrollMagic.Scene({
		triggerElement: headerMenuWrap,
		triggerHook: 0
	})
		.setClassToggle(headerMenuWrap, 'fixed')
		.setPin(headerMenuWrap)
		.addTo(controller);

	// create scene for header menu
	new ScrollMagic.Scene({
		triggerElement: headerMenuWrap,
		triggerHook: 0.5
	})
		.setClassToggle('.header__sub-menu-wrap', 'bottom')
		//	.addIndicators({name: 'menu'})
		.addTo(controller);

	headerScene.on('start', function (event) {
		tlHeader.play();
	});

	headerScene.on('leave', function (event) {
		tlHeader.reverse();
	});
}

function calculationScrollMagic () {
	if (!$(calculatorWrap).length) {
		return false;
	}

	const controller = new ScrollMagic.Controller();
	let tlCalculation = new TimelineMax();

	//	create timeline for calculator block
	tlCalculation
		.from(calculatorMain, 1, {y: 300, autoAlpha: 0, ease: Power1.easeNone}) // eslint-disable-line no-undef
		.from(calculatorLeft, 1, {x: -300, autoAlpha: 0, ease: Power1.easeOut}, 2) // eslint-disable-line no-undef
		.from(calculatorRight, 1, {x: 300, autoAlpha: 0, ease: Power1.easeOut}, 2); // eslint-disable-line no-undef

	//	create scene for calculator
	new ScrollMagic.Scene({
		triggerElement: calculatorWrap,
		triggerHook: 0.8,
		reverse: false
	})
		.setTween(tlCalculation)
		//	.addIndicators({name: 'calc'})
		.addTo(controller);
}

function infoScrollMagic () {
	if (!$infoItem.length) {
		return false;
	}

	const controller = new ScrollMagic.Controller();

	// create scene for info block
	$infoItem.each(function () {
		let $this = $(this);

		const infoScene = new ScrollMagic.Scene({
			triggerElement: this,
			triggerHook: 0.5,
			reverse: false
		})
			.setClassToggle(this, 'fade-in')
			//	.addIndicators({name: 'info'})
			.addTo(controller);

		infoScene.on('start', function (event) {
			if (!$this.hasClass('count')) {
				return false;
			}

			let cont = {val: 0};

			TweenLite // eslint-disable-line no-undef
				.to(cont, 4, {
					val: count,
					roundProps: 'val',
					onUpdate: function () {
						$counter.text(cont.val);
					},
					delay: 1,
					ease: Power0.easeOut // eslint-disable-line no-undef
				});
		});
	});
}

function productScrollMagic () {
	if (!$productInfo.length) {
		return false;
	}

	if ($(window).width() < 1024) {
		return false;
	}

	// const controller = new ScrollMagic.Controller();
	//
	// new ScrollMagic.Scene({
	// 	triggerElement: '.item__info-wrap',
	// 	triggerHook: 0.2,
	// 	duration: '100%'
	// })
	// 	.setPin('.item__info-wrap')
	// 	// .addIndicators({name: 'info'})
	// 	.addTo(controller);
}

// ----------------------------------------
// Exports
// ----------------------------------------

export {headerScrollMagic, firstSlideAnimation, calculationScrollMagic, infoScrollMagic, productScrollMagic};



// WEBPACK FOOTER //
// ./_HTML/src/js/_modules/scrollmagic.js